<template>
  <div id="examination-photos" class="w-full">
    <h4 class="mb-5 text-sm leading-6 text-center text-gray-900 border-b">Foto</h4>
    <div class="column" style="text-align: center">
      <button
        v-if="selected.length > 0"
        class="relative items-center hidden px-4 py-2 mt-5 -ml-px text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-red-600 border border-transparent rounded-md md:inline-flex hover:bg-red-500 focus:outline-none"
        @click="delete_photos"
      >
        <i class="delete icon"></i>Cancella
      </button>
    </div>
    <vue-dropzone
      ref="dropzone"
      id="photos-dropzone"
      :options="dropzoneOptions"
      @vdropzone-success="upload_success"
      @vdropzone-error="upload_error"
      :useCustomSlot="true"
      :includeStyling="false"
    >
      <div class="grid grid-cols-3 my-5">
        <photo
          class="col-span-3 mx-auto sm:col-span-1"
          v-for="(photo, index) in this.examination.photos"
          @selected="select_photo"
          @gallery="openGallery"
          :photo="photo"
          :index="index"
          :key="photo.id"
        ></photo>
      </div>
      <button class="w-full px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-700">Carica</button>
    </vue-dropzone>
  </div>
</template>
<script>
import Vue from "vue";
import store from "../../../store";
import { mapState } from "vuex";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import PhotoAPI from "../../../api/photo.js";
import Photo from "./Photo";
import PhotoGallery from "./PhotoGallery";

export default {
  data() {
    return {
      selected: [],
    };
  },

  components: {
    Photo,
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("examination", ["examination"]),
    ...mapState("photo", ["photos"]),
    dropzoneOptions() {
      let token = document.head.querySelector('meta[name="csrf-token"]')
        .content;
      return {
        url: PhotoAPI.uploadURL(this.examination.id),
        thumbnailWidth: 150,
        dictDefaultMessage: "<i class='cloud upload icon'></i>CARICA",
        addRemoveLinks: true,
        acceptedFiles: "image/*",
        headers: {
          "X-CSRF-Token": token,
          Authorization: "Bearer " + (this.user ? this.user.access_token : ""),
        },
      };
    },
  },

  methods: {
    async upload_success(file_element, photo) {
      this.$refs.dropzone.removeFile(file_element);
      this.examination.photos.push(photo);
    },
    upload_error(file_element, message, xhr) {
      this.$refs.dropzone.removeFile(file_element);
    },
    openGallery(id) {
      $("#examination-photos").insertAdjacentHTML(
        "beforeend",
        `<div id="gallery"></div>`
      );
      const index = _.findIndex(
        this.examination.photos,
        (photo) => photo.id == id
      );
      const gallery = Vue.extend(PhotoGallery);
      const vm = new gallery({
        store,
        propsData: {
          index: index,
          photos: this.examination.photos,
        },
      }).$mount("#gallery");
    },
    select_photo(id) {
      let index = _.indexOf(this.selected, id);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }
    },
    delete_photos() {
      if (confirm("Vuoi cancellare le foto selezionate?")) {
        this.$store.dispatch("photo/destroy", {
          examination_id: this.examination.id,
          photo_ids: this.selected,
        });

        this.examination.photos = this.examination.photos.filter(
          (photo) => this.selected.findIndex((id) => photo.id == id) == -1
        );
        this.selected = [];
        $$(".photo").forEach((photo) => photo.classList.remove("selected"));
      }
    },
  },
};
</script>
